/**
 * @architecture-header 1
 * @layer app
 * @domain parallel-development
 * @responsibility Reserve Agent A's Settings-pane content contribution seam.
 * @state-owner Agent A feature modules
 * @allowed-imports React types; shared composition contract; Agent A module public APIs
 * @forbidden Agent B modules; routes; direct API clients
 * @public-api SettingsShell's SettingsPane
 * @side-effects none until an Agent A card contributes content
 * @tests frontend/packages/workspace-web/src/modules/settings-account/components/AccountSettingsSurface.test.tsx,
 *   frontend/packages/workspace-web/src/modules/settings-preferences/components/PreferencesSurface.test.tsx,
 *   frontend/packages/workspace-web/src/modules/settings-general/components/GeneralSettingsSurface.test.tsx,
 *   frontend/packages/workspace-web/src/modules/settings-users/components/UsersSettingsSurface.test.tsx,
 *   frontend/packages/workspace-web/src/modules/settings-sso/components/SsoSettingsSurface.test.tsx,
 *   frontend/packages/workspace-web/src/modules/settings-subscription/components/SubscriptionSettingsSurface.test.tsx,
 *   frontend/packages/workspace-web/src/modules/settings-ai-assistant/components/AiAssistantSettingsPage.test.tsx
 */

import type { ReactNode } from 'react';
import { AccountSettingsPage } from '../../../modules/settings-account';
import { AiAssistantSettingsPage } from '../../../modules/settings-ai-assistant';
import { GeneralSettingsPage } from '../../../modules/settings-general';
import { InvitationsSettingsPage } from '../../../modules/settings-invitations';
import { PreferencesPage } from '../../../modules/settings-preferences';
import { SsoSettingsPage } from '../../../modules/settings-sso';
import { SubscriptionSettingsPage } from '../../../modules/settings-subscription';
import { UsersSettingsPage } from '../../../modules/settings-users';
import type { SettingsPaneContentContext } from '../types';

export function agentASettingsPaneContent(
  context: SettingsPaneContentContext,
  fallback: ReactNode,
): ReactNode | undefined {
  void fallback;
  if (context.tab === 'account') {
    return <AccountSettingsPage mobile={context.surface === 'mobile'} />;
  }
  if (context.tab === 'preferences') {
    return <PreferencesPage mobile={context.surface === 'mobile'} />;
  }
  if (context.tab === 'general') {
    return <GeneralSettingsPage mobile={context.surface === 'mobile'} />;
  }
  if (context.tab === 'users') {
    return <UsersSettingsPage mobile={context.surface === 'mobile'} />;
  }
  if (context.tab === 'invitations') {
    return <InvitationsSettingsPage mobile={context.surface === 'mobile'} />;
  }
  if (context.tab === 'sso-security') {
    return <SsoSettingsPage mobile={context.surface === 'mobile'} />;
  }
  if (context.tab === 'subscription') {
    return <SubscriptionSettingsPage mobile={context.surface === 'mobile'} />;
  }
  if (context.tab === 'ai-assistant') {
    return <AiAssistantSettingsPage mobile={context.surface === 'mobile'} />;
  }
  return undefined;
}
